import { createSelector } from 'reselect';

import { selectStore } from './view';

export const selectSelectedBoundingPolyGroup = createSelector(
  selectStore,
  (s) => s.selectedPolyGroups
);
